import request from "@/utils/request";

export const urls = {
  GetReportGroupsAsync: "/api/Role/GetReportGroupsAsync", //获取报表模块
  GetPageList: "/api/Report/GetPageList",
  Get: "/api/Report/Get",
  Add: "/api/Report/Add",
  Edit: "/api/Report/Edit",
  Delete: "/api/Report/Delete",
  FavorGetList: "/api/UserFavorReport/GetList",
  FavorAdd: "/api/UserFavorReport/Add",
  FavorDelete: "/api/UserFavorReport/Delete",
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}
const apis = {};
for (const key in urls) {
  const url = urls[key];
  apis[key] = (params, option = {}) => {
    return sendRequest(url, params, "post", option);
  };
}
export default apis;
